import { SpecialMenuCard } from 'src/gql/graphql';

import useSpecialMenuCards from './use-special-menu-cards';

export function specialsHaveFilterableData(specials: SpecialMenuCard[]): boolean {
  return specials.some(
    (s) => (s.applicablePreOrderTypes?.length ?? 0) > 0 || s.isBundledDiscount != null || s.recurringSchedule != null
  );
}

export function useHasFilterableSpecials({ skip = false } = {}): { hasFilterableData: boolean; loading: boolean } {
  const { specials, loading } = useSpecialMenuCards({ skip });

  return { hasFilterableData: specialsHaveFilterableData(specials), loading };
}
